import moment from 'moment';

/**
 * Normalize booking data into a friendly format.
 * @param {object} booking
 * @return {object}
 */
const bookingResponseFormatter = booking => {
  if (booking.isFormatted) {
    return booking;
  }

  const formatted = {};
  for (const key in booking) {
    if (!booking.hasOwnProperty(key)) {
      continue;
    }

    const camelCaseKey = key.replace(/_(\w)/g, (m, w) => w.toUpperCase());
    formatted[camelCaseKey] = booking[key];
  }

  formatted.appointmentTime = moment(booking.appointment_date).valueOf();
  formatted.isFormatted = true;
  return formatted;
};

export { bookingResponseFormatter };
